import React, { useCallback, useEffect, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useLocation, useParams } from 'react-router-dom';
import FormSection from 'components/shared/FormSection';
import { showToast } from 'utils/helpers';
import {
  createWarrantyPeriod,
  getWarrantyPeriod,
  updateWarrantyPeriod,
} from 'services/warranty-period.service';
import WarrantyPeriodInformation from './components/add/WarrantyPeriodInformation';
import WarrantyPeriodStatus from './components/add/WarrantyPeriodStatus';

const defaults = { period: null, is_active: 1 };

const WarrantyPeriodAddPage = () => {
  const methods = useForm({ defaultValues: defaults });
  const { warranty_period_id } = useParams();
  const { pathname } = useLocation();
  const disabled = useMemo(() => pathname.includes('/detail/'), [pathname]);

  const loadDetail = useCallback(() => {
    if (!warranty_period_id) return methods.reset(defaults);
    return getWarrantyPeriod(warranty_period_id).then((value) => methods.reset(value));
  }, [warranty_period_id, methods]);

  useEffect(() => { loadDetail(); }, [loadDetail]);

  const onSubmit = async (values) => {
    try {
      const payload = {
        period: Number(values.period),
        is_active: values.is_active ? 1 : 0,
      };
      if (warranty_period_id) {
        await updateWarrantyPeriod(warranty_period_id, payload);
        showToast.success('Chỉnh sửa thành công.');
      } else {
        await createWarrantyPeriod(payload);
        showToast.success('Thêm mới thành công.');
        methods.reset(defaults);
      }
    } catch (error) {
      showToast.error(error?.message || 'Có lỗi xảy ra.');
    }
  };

  const detailForm = [
    {
      id: 'information',
      title: 'Thông tin thời hạn bảo hành',
      component: WarrantyPeriodInformation,
      fieldActive: ['period'],
    },
    { id: 'status', title: 'Trạng thái', component: WarrantyPeriodStatus },
  ];

  return (
    <FormProvider {...methods}>
      <FormSection detailForm={detailForm} onSubmit={onSubmit} disabled={disabled} />
    </FormProvider>
  );
};

export default WarrantyPeriodAddPage;
